import React from "react";
import { Formik } from "formik";
import {
  MimaButton,
  MimaDateInput,
  MimaDropdown,
  MimaInput,
  MimaText,
  MimaTextArea,
  Modal,
} from "../../../components";
import { amountFormatter } from "../../../utils/utils";

const VerifyP2PPayment = ({
  loading,
  onSubmit,
  closeModal,
  statusData,
  validationSchema,
  singleItem,
}) => {
  return (
    <Modal closeModal={closeModal}>
      <MimaText variant="subtitleBold" align="center" mb="7" width={38}>
        Verify P2P Payment by {singleItem.buyer.username} (Buyer)
      </MimaText>
      <Formik
        initialValues={{
          amount: singleItem?.buyerDebitValue.amount,
          buyerPaymentDateTime: "",
          buyerStatus: "",
          note: "",
        }}
        onSubmit={onSubmit}
        validationSchema={validationSchema}
      >
        {({
          handleChange,
          handleBlur,
          handleSubmit,
          setFieldValue,
          values,
          errors,
          touched,
        }) => (
          <div>
            <MimaText mb={2} labelTitle="Confirm Buyer Paid">
              {amountFormatter(singleItem.buyerDebitValue.currencyCode).format(
                singleItem?.buyerDebitValue.amount
              )}
            </MimaText>
            <MimaText mb={2} labelTitle="Confirm Reference Code">
              {singleItem?.referenceCode}
            </MimaText>
            <MimaInput
              name="amount"
              labelTitle="Amount"
              type="number"
              placeholder="Enter amount"
              value={values.amount}
              onChange={handleChange("amount")}
              onBlur={handleBlur("amount")}
              error={errors.amount}
              touched={touched.amount}
            />

            <MimaDateInput
              labelTitle="Buyer Payment Date/Time"
              name="buyerPaymentDateTime"
              value={values.buyerPaymentDateTime}
              onChange={(text) => {
                setFieldValue("buyerPaymentDateTime", text);
              }}
              onBlur={handleBlur}
              touched={touched.buyerPaymentDateTime}
              error={errors.buyerPaymentDateTime}
              showTimeSelect
              mt={2}
              width={38}
            />
            <MimaDropdown
              labelTitle="Status"
              placeholder="Select status"
              name="buyerStatus"
              data={statusData}
              value={values.buyerStatus}
              id="buyerStatus"
              onChange={(data) => {
                setFieldValue("buyerStatus", data.key);
              }}
              error={errors.buyerStatus}
              touched={touched.buyerStatus}
            />

            <MimaTextArea
              labelTitle="Note"
              variant="message"
              placeholder="Enter Note"
              name="note"
              value={values.note}
              onChange={handleChange}
              onBlur={handleBlur}
              error={errors.note}
              touched={touched.note}
              mb={2}
            />
            <MimaButton
              title="Continue"
              width={38}
              onClick={handleSubmit}
              loading={loading}
            />
          </div>
        )}
      </Formik>
    </Modal>
  );
};
export default VerifyP2PPayment;
